import React from 'react';
import AppTherapyMaterial from './components';
import Layout from '../../layouts/index';

const TherapyMaterial = () => {
    return (
        <Layout>
            <AppTherapyMaterial />
        </Layout>
    );
};

export default TherapyMaterial;
